module.exports = __webpack_public_path__ + "static/media/myBet_2.911cec40.mp3";